import { connect } from 'react-redux';
import { IState } from '../../store';

import { ITechnicalCharacterProps, TechnicalCharacter } from './index';

function mapStateToProps(state: IState): ITechnicalCharacterProps {
  return {
    businessShoppingCenter: state.offerData.businessShoppingCenter,
    offer: state.offerData.offer,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TechnicalCharacterContainer = connect<ITechnicalCharacterProps, any, any>(mapStateToProps)(
  TechnicalCharacter,
);
